export default class Popover {

  constructor() {
    this.menu = document.querySelector('#user');
    this.popperButton = document.querySelector('.user-dropdown');

    if ( this.popperButton && this.menu ) {
      this.popperButton.addEventListener('click', this.toggleMenu.bind(this))
      this.hideMenuOnClickOutside();
    }
  }

  toggleMenu(evt) {
    evt.preventDefault();
    this.menu.classList.toggle('active');
  }

  hideMenuOnClickOutside() {
    document.addEventListener('click', ( evt ) => {
      if (
        this.popperButton &&
        this.menu &&
        this.menu.classList.contains('active') &&
        !this.popperButton.contains(evt.target)
      ) {
        this.menu.classList.remove('active');
      }
    });
  }
}
